module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAVCAYAAAA0GqweAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEUSURBVHgB7de5SkNBFMbxk8QVRXEBV8S4oLhhJVgpFr6DvYi9hS/kA/gcgp02oq0kKZKQPZDtf5jvDaZJMQd+zJ3JzL1fujk5C7WBIZaxhiXksY4ONjHAKuYxgQzmdO4MXe3P6/cVVDGNKeyijB3N/dy2vn+NWe1d1Pcm0chpwyPqONSzjy84wRce0MQtjtBSgBsFe0YFd3hS+C1841h/7BXvGv3MDO7RwxuuFPASp9jHR9bGvFLA2EoBYysFjK0UMLZSwNhKAWMrBYytFDC2xj5gRuMBShb6gD3ULPQp3kP8aM2fF9C3cL3Pau7rfv1vW+gr/Kr/a6HnKFroMUzv+MQF/rXm/Y23D+d6b8FC72Oa/40AMFcvwp9mj80AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/barcode.png
// module id = ./src/assets/barcode.png
// module chunks = 1